// extracted by mini-css-extract-plugin
export default {"table":"TableFeatures-module--table--4df75"};